export const countryCodePhoneRegExp = /^(\+[1]\s\([0-9]{3}\)\s*|[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
export const countryCodePhoneMask = ['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
export const phoneRegExp = /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/;
export const phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
export const friendlyPhone = phoneNumber => {
  if (!phoneNumber) {
    return;
  }
  const cleaned = phoneNumber.replace(/\D/g, '');
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] ? '+1 ' : '';
    // eslint-disable-next-line consistent-return
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
};
